import React, { FC, useState } from 'react';
import classNames from 'classnames';
import NavigationDropDownLink from '../components/NavigationDropDownLink';
import MaterialIcon from './MaterialIcon';
import { AgeCategory } from '../../../models/AgeCategory';
import './AgeCategorySelector.scss';
import { DropDownMenu } from './DropDownMenu';
import { updateFilterParam, useProductFilters } from '../filter/useProductFilters';
import { useTranslation } from 'react-i18next';
import { AGE_CATEGORY_SEARCH_PARAM, useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';
import { To, useSearchParams } from 'react-router-dom';
import { resetPageParam } from '../hooks/usePaginationAndSortParams';

type Props = {
    readonly className?: string;
};

const AgeCategorySelector: FC<Props> = ({ className }) => {
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const { value: ageCategory } = useAgeCategorySearchParam();
    const [expanded, setExpanded] = useState(false);
    const { productFilter } = useProductFilters();

    const createAgeCategoryLink = (age: string): To => {
        let nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.set(AGE_CATEGORY_SEARCH_PARAM, age);

        const nextFilters = { ...productFilter };
        delete nextFilters['ageCategory'];

        nextSearchParams = updateFilterParam(nextSearchParams, nextFilters);
        nextSearchParams = resetPageParam(nextSearchParams);

        return { search: nextSearchParams.toString() };
    };

    return (
        <DropDownMenu
            expanded={expanded}
            align="right"
            onToggleClick={setExpanded}
            onClickOutside={setExpanded}
            className={classNames('age-category-selector', className)}
            label={t(`ageCategory.${ageCategory}`, {
                defaultValue: ageCategory
            })}
            dataDisplayname="AgeCategorySelector"
        >
            {Object.values(AgeCategory).map(age => {
                const isActive = age === ageCategory;
                const to = createAgeCategoryLink(age);

                return (
                    <li key={age} className="age-category-selector-item">
                        <NavigationDropDownLink
                            to={to}
                            className={({ isActive }) => (isActive ? 'never-active' : undefined)}
                            onClick={() => setExpanded(false)}
                        >
                            <span>
                                {t(`ageCategory.${age}`, {
                                    defaultValue: age
                                })}
                            </span>
                            {isActive && <MaterialIcon icon="check" primary={true} />}
                        </NavigationDropDownLink>
                    </li>
                );
            })}
        </DropDownMenu>
    );
};

export default AgeCategorySelector;
